import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ROUTE_STORAGE_KEY = 'garage-renaissance-last-route';
const EXCLUDED_ROUTES = ['/auth', '/home', '/reset-password'];

export function useRoutePersistence() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasRestored = useRef(false);
  const [isReady, setIsReady] = useState(false);

  // Mark as ready after initial render completes
  useEffect(() => {
    const timer = requestAnimationFrame(() => {
      setIsReady(true);
    });
    return () => cancelAnimationFrame(timer);
  }, []);

  // Restore route only after component is ready
  useEffect(() => {
    if (!isReady || hasRestored.current) return;
    hasRestored.current = true;

    try {
      const savedRoute = localStorage.getItem(ROUTE_STORAGE_KEY);
      if (savedRoute && savedRoute !== location.pathname && !EXCLUDED_ROUTES.includes(savedRoute)) {
        navigate(savedRoute, { replace: true });
      }
    } catch (e) {
      console.error('Route restoration failed:', e);
    }
  }, [isReady, location.pathname, navigate]);

  // Save route on navigation changes (only after initial restoration)
  useEffect(() => {
    if (!hasRestored.current) return;
    
    if (!EXCLUDED_ROUTES.includes(location.pathname)) {
      try {
        localStorage.setItem(ROUTE_STORAGE_KEY, location.pathname);
      } catch (e) {
        console.error('Route save failed:', e);
      }
    }
  }, [location.pathname]);
}
